import { Link, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { ReturnIcon } from '../../assets/icons/Return'
import { TredingDownIcon } from '../../assets/icons/trending-down'
import { TrendingUpIcon } from '../../assets/icons/trending-up'
import { CardIconTitle } from '../../components/CardIconTitle/CardIconTitle'
import { GenericTable } from '../../components/GenericTable/GenericTable'
import { CardDashboard } from '../../components/CardDashboard/CardDashboard'
import { Loading } from '../../components/Loading/Loading'
import { DivTitle } from '../../components/TitlePage/TitlePage'
import { colors } from '../../theme'
import { WrapperCardsResumo } from '../Dashboard/DashBoard.style'
import {
  Div,
  DivTop,
  Span,
  Wrapper,
} from '../PredictionDetails/PredictionDetails.style'
import { WrapperTitle } from '../../layouts/LayoutTable/LayoutTable'
import { useProductsDetails } from './useProductsDetails'
import { TabelaVendas } from '../../components/TabelaVendas/TabelaVendas'

export function ProductsDetails() {
  const { productResume, clientsDetails, clientsLow, isLoading } =
    useProductsDetails()

  const location = useLocation()
  const { pathname } = location
  const pathnameArray = pathname.split('/')

  return (
    <>
      <ToastContainer theme="dark" />
      <DivTop>
        <Link
          to={pathnameArray.includes('produtos') ? '/produtos' : '/dashboard'}
        >
          <ReturnIcon />
        </Link>
        <Span>Detalhamento</Span>
      </DivTop>
      <WrapperTitle>
        <DivTitle color={colors.primaryText} size={22}>
          {productResume?.nome}
        </DivTitle>
      </WrapperTitle>
      {isLoading ? (
        <Loading contrast={false} />
      ) : (
        <WrapperCardsResumo>
          <CardDashboard
            colorTitle={colors.white}
            color={colors.white}
            background={colors.grey200}
            total={productResume?.media120Dias}
          >
            Média 180 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={productResume?.ultimos30Dias}
            percentage={productResume?.percentualUltimos30Dias}
          >
            Últimos 30 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={productResume?.ultimos60Dias}
          >
            Últimos 60 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={productResume?.ultimos90Dias}
          >
            Últimos 90 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={productResume?.ultimos120Dias}
          >
            Últimos 120 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={productResume?.ultimos150Dias}
          >
            Últimos 150 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={productResume?.ultimos180Dias}
          >
            Últimos 180 dias
          </CardDashboard>
        </WrapperCardsResumo>
      )}
      <Div>
        <Wrapper size="49">
          <CardIconTitle
            icon={<TrendingUpIcon />}
            background={colors.secondary}
            title="Clientes em alta"
          />
          <GenericTable
            font="14px"
            spacing="20px"
            headers={['Cliente', 'Percentual']}
          >
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              clientsDetails.map(details => (
                <tr key={details.id}>
                  <td className="col2">{details.nome}</td>
                  <td className="col3">{details.percentual}%</td>
                </tr>
              ))
            )}
          </GenericTable>
        </Wrapper>
        <Wrapper size="49">
          <CardIconTitle
            icon={<TredingDownIcon />}
            background={colors.error}
            title="Clientes em baixa"
          />
          <GenericTable
            font="14px"
            spacing="20px"
            headers={['Cliente', 'Percentual']}
          >
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              clientsLow.map(item => (
                <tr key={item.id}>
                  <td className="col2">{item.nome}</td>
                  <td className="col3">{item.percentual}%</td>
                </tr>
              ))
            )}
          </GenericTable>
        </Wrapper>
      </Div>
      <TabelaVendas />
    </>
  )
}
